import SportsCard from "./components/sportsCard/SportsCard"
import Layout from "@/components/Layout"

export default function Sports() {
  
  return (
    <Layout>
      <main style={{ minHeight: "100vh" }}>
        <div>
          <SportsCard />
        </div>
      </main>
    </Layout>
  )
}
